const ACCESS = "leninka_access_token"
const REFRESH = "leninka_refresh_token"

export const tokenStorage = {
  getAccessToken: (): string | null => {
    try {
      return localStorage.getItem(ACCESS)
    } catch {
      return null
    }
  },
  setTokens: (access: string, refresh?: string | null) => {
    try {
      localStorage.setItem(ACCESS, access)
      if (refresh) {
        localStorage.setItem(REFRESH, refresh)
      }
    } catch {
      /* ignore */
    }
  },
  getRefreshToken: (): string | null => {
    try {
      return localStorage.getItem(REFRESH)
    } catch {
      return null
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(ACCESS)
      localStorage.removeItem(REFRESH)
    } catch {
      /* ignore */
    }
  },
}
